import omit from 'lodash/omit';
import { BuildErrorContext } from '../interface';

export class BuildError extends Error {
  constructor(private previousError: Error, private context: BuildErrorContext) {
    super(`BuildError: ${previousError.message}`);

    if (this.message.includes('NullInjectorError')) {
      this.message = `BuildError: Cannot to create component for "${this.context.tagName}" tag, one of dependency is required, but got null. It may happens when used child tag without parent tag.`;
    }

    this.message += `\nContext details: ${this.getPrintableContext()}`;

    Object.setPrototypeOf(this, new.target.prototype);
  }

  getPreviousError(): Error | undefined {
    return this.previousError;
  }

  getContext(): BuildErrorContext {
    return this.context;
  }

  getPrintableContext(): string {
    const excludedMarkupProperties: (keyof BuildErrorContext)[] = ['documentMarkup', 'tagOuterMarkup'];

    return JSON.stringify(omit(this.context, excludedMarkupProperties));
  }
}
